import React from "react";
import { message, Upload } from "antd";
import { PhotoIcon } from "Shared/icons";

import "./uploadAvatar.scss";
import { func, string } from "prop-types";
import { fetch } from "Shared/config";

const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(img);
};

export const UploadAvatar = ({ photoUrl, localImageUrl, setLocalImageUrl, setFile }) => {
	const handleChange = (info) => {
		if (info.file.percent === 100) {
			getBase64(info.file.originFileObj, (url) => {
				setLocalImageUrl(url);
			});
		}
	};
	const beforeUpload = (file) => {
		const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
		if (!isJpgOrPng) {
			message.error("You can only upload JPG/PNG file!");
		}
		const isLt2M = file.size / 1024 / 1024 < 2;
		if (!isLt2M) {
			message.error("Image must smaller than 2MB!");
		}
		setFile(file);
		return isJpgOrPng;
	};

	function getPhoto() {
		if (typeof photoUrl === "string") {
			let avatar = `${fetch.base}${photoUrl}`;
			if (!photoUrl.includes(".png") && !photoUrl.includes(".jpg") && !photoUrl.includes(".jpeg")) {
				avatar = `${fetch.base}${photoUrl}.png`;
			}
			return avatar;
		}
	}

	return (
		<>
			<Upload
				name="avatar"
				listType="picture-circle"
				className="avatar-uploader"
				showUploadList={false}
				beforeUpload={beforeUpload}
				onChange={handleChange}
				accept={"image/jpeg,image/png"}
			>
				{photoUrl && !localImageUrl && (
					<img src={getPhoto()} alt="avatar" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />
				)}
				{localImageUrl && (
					<img src={localImageUrl} alt="avatar" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />
				)}
				{!photoUrl && !localImageUrl && <PhotoIcon />}
			</Upload>
		</>
	);
};

UploadAvatar.propTypes = {
	photoUrl: string,
	localImageUrl: string,
	setLocalImageUrl: func,
	setFile: func,
};
